import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueJsonp from 'vue-jsonp'
import store from './store'
import axios from 'axios'
import './plugins/element.js'
import './custom.scss'

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.use(VueJsonp)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
